/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"
import { GetCampaignPaymentsGroupedByCampaignRequestParams } from "./campaignPayments.types"

export const CAMPAIGN_PAYMENT_TYPE = {
  SINGLE: "SINGLE",
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
  CANCEL: "CANCEL",
}

export default ($axios: any) => ({
  // 결제내역 조회
  async index(data?: any) {
    return camelize(await $axios.get(`/campaign/payments`, snakelize({ params: data })))
  },

  async indexGroupedByCampaign(data?: GetCampaignPaymentsGroupedByCampaignRequestParams) {
    return camelize(await $axios.get(`/campaign/payments/grouped-by-campaign`, snakelize({ params: data })))
  },
})
